import React from 'react'
import { Card, Row } from 'react-bootstrap'
import { FaExternalLinkAlt } from 'react-icons/fa'
import './company-detail.css'

/**
 * ReasonsForShutdown Component
 * 
 * Displays company shutdown reasons with detailed information and external sources.
 * Renders a list of shutdown reasons organized by label, reason description, and supporting
 * details with optional external source links. This is a presentational component that receives
 * shutdown reason data via props. Maps through reasons array displaying each reason with
 * collapsible detail sections. Suitable for inclusion in company detail pages.
 * 
 * @param {Object} props - Component props
 * @param {Array} props.reasonForShutdown - Array of reason objects with label, reason, and details
 * @returns {JSX.Element} Card body displaying shutdown reasons with expandable details
 */
function ReasonsForShutdown(props) {

    return (
        <Card.Body id="reasonsforshutdown">
            {!props?.reasonForShutdown
                ? ""
                : (<Row>
                    <ol className="companydetailproductlist">
                        {props.reasonForShutdown.map((reason, index) =>
                            <div key={index}>
                                <li className="companydetailbodydata companydetailreasonlabel">{reason.label}</li>
                                <p className="companydetailbodydata">{reason.reason}</p>

                                <ul className="companydetailproductlist2">
                                    {reason.details
                                        ? (reason.details.map((detail, index) =>
                                            <li key={index}>{detail.text}
                                                {!detail.source
                                                    ? ""
                                                    : (<a href={detail.source} target="_blank" rel="noopener noreferrer">
                                                        <sup><FaExternalLinkAlt className="companydetailsourceicon" /></sup>
                                                    </a>)
                                                }
                                            </li>
                                        ))
                                        : ""
                                    }
                                </ul>

                                <hr />
                            </div>
                        )}
                    </ol>
                </Row>)
            }
        </Card.Body>
    )
}

export default ReasonsForShutdown;